import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
  render() {
    return (
      <footer id="footer" className="p-70px-t p-30px-b footer bg-dark text-white">
         <div className="container">
            <div className="row">
               {/* 会社情報 */}
               <div className="col-lg-4 col-md-6 m-30px-b">
                  <div className="footer-widget">
                     <div className="mb-4">
                        <img
                           src={process.env.PUBLIC_URL + "/assets/img/proto.ai.png"}
                           alt="protoAI"
                           style={{height: '50px', width: 'auto', marginBottom: '20px'}}
                        />
                        <h3 className="widget-title font-weight-bold">株式会社protoAI</h3>
                     </div>
                     <p className="text-white-50 mb-3">
                        「時間」という最大の制約から、日本のイノベーションを解放することが私たちの使命です。
                     </p>
                     <div className="contact-info">
                        <p className="mb-2">
                           <i className="icofont-google-map mr-2"></i>
                           東京都渋谷区神宮前1-2-3 protoAIビル 5F
                        </p>
                        <p className="mb-2">
                           <i className="icofont-phone mr-2"></i>
                           03-1234-5678
                        </p>
                        <p className="mb-0">
                           <i className="icofont-envelope mr-2"></i>
                           info@protoai.jp
                        </p>
                     </div>
                  </div>
               </div>

               {/* サービス */}
               <div className="col-lg-2 col-md-6 m-30px-b">
                  <div className="footer-widget">
                     <h4 className="widget-title font-weight-bold mb-4">サービス</h4>
                     <ul className="footer-links list-unstyled">
                        <li className="mb-2"><Link to="/services" className="text-white-50">サービス一覧</Link></li>
                        <li className="mb-2"><Link to="/pricing" className="text-white-50">料金プラン</Link></li>
                        <li className="mb-2"><Link to="/flow" className="text-white-50">導入の流れ</Link></li>
                     </ul>
                  </div>
               </div>

               {/* 企業情報 */}
               <div className="col-lg-2 col-md-6 m-30px-b">
                  <div className="footer-widget">
                     <h4 className="widget-title font-weight-bold mb-4">企業情報</h4>
                     <ul className="footer-links list-unstyled">
                        <li className="mb-2"><Link to="/about" className="text-white-50">私たちについて</Link></li>
                        <li className="mb-2"><Link to="/cases" className="text-white-50">導入事例</Link></li>
                        <li className="mb-2"><Link to="/faq" className="text-white-50">よくある質問</Link></li>
                     </ul>
                  </div>
               </div>

               {/* お問い合わせ */}
               <div className="col-lg-4 col-md-6 m-30px-b">
                  <div className="footer-widget">
                     <h4 className="widget-title font-weight-bold mb-4">お問い合わせ</h4>
                     <p className="text-white-50 mb-3">
                        AIで事業を加速させたい方は、お気軽にご相談ください。
                     </p>
                     <Link to="/contact" className="btn btn-default btn-filled animated-btn">
                        無料相談を申し込む <i className="icofont-arrow-right ml-1"></i>
                     </Link>
                  </div>
               </div>
            </div>

            {/* コピーライト */}
            <div className="row">
               <div className="col-12">
                  <div className="footer-copyright text-center pt-4 mt-4" style={{borderTop: '1px solid rgba(255,255,255,0.1)'}}>
                     <p className="text-white-50 mb-0">
                        &copy; 2024 株式会社protoAI. All rights reserved.
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </footer>
    );
  }
}

export default Footer;
